module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jm8Cl"))).then(() => parcelRequire('1iHdE'));